module.exports = __webpack_public_path__ + "images/corners/Crescent.a21f53730c60f27a389561474d14d417.jpg";